'use client';

import { usePathname } from 'next/navigation';

/**
 * Where a small system notice floats: the "New version available" pill
 * (components/sw-registration.tsx) and the "Offline" pill
 * (components/offline-banner.tsx).
 *
 * WHY THIS EXISTS (the Revent run on dev, 2026-10-02). Both pills were placed
 * for the old page layout, `md:top-14`, 56 px down, "under the header". The
 * workspace has no header: a window's title bar (40 px) or the full-screen
 * app bar (44 px) sits at the very top, so 56 px landed across the bottom
 * edge of the title bar and over the first line of the app itself. After a
 * deploy every returning person sees the update pill on every load until
 * they press Reload, and on dev it covered Revent's day heading each time.
 *
 * In the workspace the pill sits 8 px from the top instead: inside the band
 * of the title bar or the app bar, centred on it (a 30 px pill, 8 to 38),
 * over chrome and never over the app. Pages that do have the header keep the
 * old place. Both class strings are written out whole so Tailwind sees them.
 */
export const SYSTEM_NOTICE_TOP_WORKSPACE = 'top-2';
export const SYSTEM_NOTICE_TOP_PAGE = 'md:top-14 top-4';

export function isWorkspacePath(pathname: string | null | undefined): boolean {
  return !!pathname && (pathname === '/workspace' || pathname.startsWith('/workspace/'));
}

export function useSystemNoticeTop(): string {
  return isWorkspacePath(usePathname()) ? SYSTEM_NOTICE_TOP_WORKSPACE : SYSTEM_NOTICE_TOP_PAGE;
}
